import { Input } from '@ibsys/kit';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EditableTitle } from '@/shared/ui';
import type { SampleFormValues } from './useSampleSchema';

type Props = {
  isCreate: boolean;
  onUpdateName?: (name: string) => void;
};

export const EditableSampleTitle: FC<Props> = ({ isCreate, onUpdateName }) => {
  const { t } = useTranslation('samples');
  const { control, watch } = useFormContext<SampleFormValues>();

  const name = watch('name');

  const handleSave = (newName: string) => {
    if (!isCreate && newName !== name) {
      onUpdateName?.(newName);
    }
  };

  if (isCreate) {
    return <Input control={control} name="name" placeholder={t('newSamplePlaceholder')} className="w-64" />;
  }

  return <EditableTitle value={name || t('newSample')} placeholder={t('newSamplePlaceholder')} onSave={handleSave} />;
};
